import { render, staticRenderFns } from "./NotAvailablePartNumbers.vue?vue&type=template&id=36dcccf8&"
import script from "./NotAvailablePartNumbers.vue?vue&type=script&lang=js&"
export * from "./NotAvailablePartNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports